import { Directive, Input, TemplateRef, ViewContainerRef, effect, inject, OnDestroy } from '@angular/core';
import { AuthStore } from '@core/service/auth-store.service';

@Directive({ selector: '[appHasAnyRole]', standalone: true })
export class HasAnyRoleDirective implements OnDestroy {
  private viewCreated = false;
  private rolesRequired: string[] = [];

  private auth = inject(AuthStore);
  private tpl = inject(TemplateRef<any>);
  private vcr = inject(ViewContainerRef);

  @Input('appHasAnyRole')
  set appHasAnyRole(roles: string[] | string) {
    this.rolesRequired = Array.isArray(roles) ? roles : [roles];
    this.update();
  }

  private rx = effect(() => {
    // reexecuta quando roles mudam
    const _ = this.auth.roles();
    this.update();
  });

  private update() {
    const show = this.rolesRequired.length === 0 || this.auth.hasAny(this.rolesRequired);
    if (show && !this.viewCreated) {
      this.vcr.clear();
      this.vcr.createEmbeddedView(this.tpl);
      this.viewCreated = true;
    } else if (!show && this.viewCreated) {
      this.vcr.clear();
      this.viewCreated = false;
    }
  }

  ngOnDestroy() { /* signals cleanup automático no Angular 17+ */ }
}
